import $http from '@/api/index'
/**
 * @description 新增路径
 * @constructor
 */
function SetSite(content, type) {
  let getUrl = {
    method: 'POST',
    url: 'config/SetSite',
    requestType: 1,
    isParams: true
  }
  let pars = {
    jsonString: content,
    type: type
  }
  return $http(getUrl, pars)
}

function GetSite(type) {
  let urlJson = '';
  switch (type) {
    case 0:
      urlJson = 'config/PortalBackstage.json';
      break;
    case 1:
      urlJson = 'config/Portal.json';
      break;
    case 2:
      urlJson = 'config/IM.json';
      break;
    case 3:
      urlJson = 'config/App.json';
      break;
    default:
      urlJson = 'config/PortalBackstage.json';
      break;
  }
  let getUrl = {
    method: 'GET',
    url: 'config/GetSite',
    requestType: 1,
  }
  let pars = {
    type: type
  }
  return $http(getUrl, pars)
}

export default {
  SetSite,
  GetSite
}
